import "react";
import { jsx as e, jsxs as n } from "react/jsx-runtime";
var s = (o) => /* @__PURE__ */ n("svg", {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: [/* @__PURE__ */ e("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35V35C11.715 35 5 28.285 5 20V20C5 11.715 11.715 5 20 5V5C28.285 5 35 11.715 35 20V20C35 28.285 28.285 35 20 35Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ e("path", {
    d: "M26.6666 16.6667L18.3333 25L13.3333 20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
export {
  s as default
};

//# sourceMappingURL=DialogSuccess.js.map